import React from "react";
import CustomMuiModal from "./CustomMuiModal";
import LoadingSpinner from "../UI/LoadingSpinner";

const LoadingModal = () => {
  return (
    <CustomMuiModal open={true} onClose={() => {}}>
      <div className="full-display-flex">
        <LoadingSpinner />
      </div>
    </CustomMuiModal>
  );
};

export default LoadingModal;
